<template>
    <v-select v-model="internalValue" :items="fields" item-title="title" item-value="column_name"
        @update:modelValue="onUpdate" return-object hide-details variant="solo" density="compact"
        menu-icon="fal fa-chevron-down" :menu-props="{ class: 'kyano-menu' }" />
</template>

<script>
import { useAppStore } from "@/stores/appStore";
export default {
    name: "FieldsSelect",
    props: {
        modelValue: [String, Number, Object],
    },
    computed: {
        internalValue: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
        fields() {
            return this.appStore.fields || [];
        },

        appStore() {
            return useAppStore();
        },
    },
    methods: {
        onUpdate(val) {
            this.$emit("update:modelValue", val);
            this.$emit("change", val); // optioneel: apart change event
        },
    },
};
</script>
